import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import regression from 'highcharts-regression';

import Highchart from "./Highchart";
import HighchartsConfig from '../../utils/HighchartsConfig';
import ReportDataMasseuse from "../utils/ReportDataMasseuse";
import DetailedReport from "../containers/DetailedReport";
import { withTheme } from '@material-ui/core';

//import {imagesProcessedData} from "../data/reports";

// initialize regression plugin
//regression(Highcharts);

class ImagesProcessedReport extends Component {
	constructor(props, context) {
		super(props, context);

		let {chartClasses, theme, filter} = props;

		this.state = {
			chartConfig: HighchartsConfig.merge({
				chart: {
					className: chartClasses.chart
				},
				title: {
					align: "left",
					text: "Images Scanned",
					style: {color: theme.palette.primary.darkGrey, fontSize: 14, fontWeight: 400}
				},
				accessibility: {
					point: {
						valueSuffix: " images"
					},
					description: `The number of images scanned per day over the last ${filter.previousDays} days.`
				},
				yAxis: {
					title: "",
					lineWidth: 0,
					gridLineWidth: 0,
					minRange : 0.1,
					allowDecimals: false,
					endOnTick: false,
					labels: {
						y: 0,
						style: {
							fontSize: 14,
							color: theme.palette.primary.darkGrey,
							fontWeight: 400
						}
					}
				},
				xAxis: {
					type: "datetime",
					tickWidth: 0,
					offset: 20,
					labels: {
						y: 35,
						rotation: -45,
						align: "center",
						style: {
							fontSize: 14,
							color: theme.palette.primary.darkGrey,
							fontWeight: 400
						}
					},
				},
				plotOptions: {
					column: {
						//borderColor: theme.palette.secondary.orange
					}
				},
				series: [{
					type: "column",
					name: "Images",
					color: theme.palette.secondary.green
				}]
			}, {
				modifyTickInterval: true,
				previousDays: filter.previousDays
			})
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.data !== this.props.data) {
			let {chartConfig} = this.state,
				{data, suggestedClassname} = this.props;
				// TEMP
				//data = imagesProcessedData;

			if (data) {
				ReportDataMasseuse.convertDatesToMillis(data);
				chartConfig.series[0].className = chartConfig.series[0].className = suggestedClassname;
				chartConfig.series[0].data = ReportDataMasseuse.massageData(data, "period", "images");
				chartConfig.yAxis.labels.enabled = ReportDataMasseuse.getMaxValue(data, "images") !== 0;
			} else {
				chartConfig.series[0].data = null;
			}

			this.setState({chartConfig: chartConfig});
		}
	}

	render() {
		let {chartConfig} = this.state,
			{fidoError} = this.props;

		return (
			<DetailedReport
				fidoError={fidoError}
				ready={chartConfig.series[0].data && chartConfig.series[0].data.length > 0 ? true : false}>
				<Highchart
					darkTheme
					pngExport
					chartConfig={chartConfig} />
			</DetailedReport>
		);
	}
}

ImagesProcessedReport.propTypes = {
	theme: PropTypes.object.isRequired,
	chartClasses: PropTypes.object.isRequired,
	showSnackbar: PropTypes.func,
	location: PropTypes.object,
	filter: PropTypes.object,
	data: PropTypes.array,
	fidoError: PropTypes.bool,
	suggestedClassname: PropTypes.string
};

export default withTheme(ImagesProcessedReport);